import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { IsEmriEditComponent } from './is-emri-edit.component';
import { IsEmriKartComponent } from './is-emri-kart.component';
import { IsEmriKartSadeComponent } from './is-emri-kart-sade.component';

@DinamikBilesen({
  id: 'is-emri',
  baslik: 'İş Emri',
  aciklama: 'İş emri oluştur',
  ikon: 'file-done',
  kategori: 'uretim',
})
class IsEmri {
  paylas_kutusu = IsEmriEditComponent;
  paylasilmis_kart = IsEmriKartComponent;
  paylasilmis_kart_sade = IsEmriKartSadeComponent;
}
